import { QueryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { useHttpClient } from '@bonusly/http-client';

import { RewardsResourcePath } from '../lib/rewards-resource-path';
import { PaginationParams, QueryKey } from '../types/rewards';
import { toSnakeCaseKeys } from '../utils/object';

type Format = 'index' | 'popular';

export interface IndexArgs<T extends Format = Format> {
	params: {
		displayFormat?: T;
		pagination: Partial<PaginationParams>;
	};
}

export const usePromotedRewards = (args: IndexArgs, options?: QueryOptions<AxiosResponse>) => {
	const rewardsCatalogService = useHttpClient('rcs');
	return useQuery<AxiosResponse>(
		[QueryKey.PromotedRewards],
		() =>
			rewardsCatalogService.get(RewardsResourcePath.PromotedRewards, {
				params: toSnakeCaseKeys(args.params),
			}),
		{
			...options,
			select: (data) => data?.data,
		}
	);
};

export const useInvalidatePromotedRewards = () => {
	const queryClient = useQueryClient();
	return () => {
		queryClient.invalidateQueries([QueryKey.PromotedRewards]);
	};
};
